import { Link } from 'react-router-dom';
import { latestMovies } from '@/mocks/movies';

export default function LatestSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">每日更新，第一时间看新片</p>
          </div>
          <Link
            to="/category/dianying"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            更多新片 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestMovies.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group flex gap-4 bg-background-50 rounded-xl p-4 hover:bg-background-200/50 transition-all duration-300"
              style={{ animationDelay: `${index * 0.06}s` }}
              data-product-shop
            >
              <div className="relative w-28 h-36 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={movie.posterImage}
                  alt={movie.title}
                  title={`${movie.title} - 小辣椒影院高清电影免费在线观看`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                {movie.isNew && (
                  <div className="absolute top-1 left-1 bg-accent-500 text-white text-xs font-bold px-1.5 py-0.5 rounded-md whitespace-nowrap">
                    NEW
                  </div>
                )}
              </div>
              <div className="flex flex-col justify-between flex-1 min-w-0">
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {movie.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{movie.englishTitle}</p>
                  <div className="flex flex-wrap items-center gap-1 mt-2">
                    {movie.tags.map((tag) => (
                      <span key={tag} className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span><i className="ri-star-fill text-accent-500 w-3 h-3 inline-flex items-center justify-center mr-0.5"></i>{movie.rating}</span>
                  <span>{movie.updateTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}